import React from 'react';
import { Button, Icon, Modal, Header } from 'semantic-ui-react'

const SeguroPermite = ({mensaje, imgIcon, permiteUpdate, permiteCancel, permiteClose, permiteDir, permiteTar, permiteOfer,
                    permiteEqu, open, styles, handleQuestionUpdDel}) => {
    return(
      <div>
        {(permiteUpdate||permiteCancel||permiteClose||permiteDir||permiteTar||permiteOfer||permiteEqu) && 
            <Modal open={open} size="tiny" style={styles.modal} trigger={
              <Button style={styles.confirmar} name="btnUpdDel" id="btnUpdDel" className="ui right labeled icon" onClick={(ev)=>handleQuestionUpdDel(ev)} primary fluid>
                {(permiteUpdate&&!mensaje) && <i className="large edit yellow icon"></i>}
                {/* {(permiteUpdate&&mensaje) && <i className="large edit yellow icon"></i>} */}
                {/* {(permiteUpdate&&mensaje) && <Icon name="remove circle" color="red" size="large" />} */}
                {/* {(permiteClose&&mensaje) && <img src={imgIcon} alt="Logo" align="right" height="16"/>} */}
                {(permiteUpdate&&mensaje) && <img src={imgIcon} alt="Logo" align="right" height="16"/>}
                
                {permiteCancel && <i className="large trash alternate yellow icon"></i>}
                {permiteClose && <i className="large trash alternate yellow icon"></i>}
                {permiteDir && <i className="large trash alternate yellow icon"></i>}
                {permiteTar && <i className="large trash alternate yellow icon"></i>}
                {permiteOfer && <i className="large trash alternate yellow icon"></i>}
                {permiteEqu && <i className="large trash alternate yellow icon"></i>}

                {(permiteUpdate&&!mensaje) && 'Confirmar MODIFICAR la O de S'}
                {(permiteUpdate&&mensaje) && mensaje}
                {permiteCancel && 'Confirmar CANCELAR la O de S'}
                {(permiteClose&&mensaje) && mensaje}
                {(permiteClose&&!mensaje) && 'Confirmar CERRAR la O de S'}
                {permiteDir && 'Confirmar DIRECCION'}
                {permiteTar && 'Confirmar TARIFA'}
                {permiteOfer && 'Confirmar OFERTA'}
                {permiteEqu && 'Confirmar EQUIPOS'}
              </Button>
            }>
                {(permiteUpdate&&!mensaje) && <Header icon='edit' color='red' content='Modificar' />}
                {(permiteUpdate&&mensaje) && <Header icon='edit' color='red' content={mensaje} />}
                {/* {(permiteUpdate&&mensaje) && <Header color='red'>{mensaje}
                                              <img src={imgIcon} alt="Logo" align="left" height="16"/>
                                            </Header>} */}
                
                {permiteCancel && <Header icon="trash" color='red' content='Cancelar' />}
                {permiteClose && <Header icon="trash" color='red' content='Cerrar' />}
                {permiteDir && <Header icon="trash" color='red' content='Dirección' />}
                {permiteTar && <Header icon="trash" color='red' content='Tarifa' />}
                {permiteOfer && <Header icon="trash" color='red' content='Oferta' />}
                {permiteEqu && <Header icon="trash" color='red' content='Equipos' />}
            
                <Modal.Content>
                    {/* <p>Esta usted seguro ?</p> */}
                    <p>
                      {(permiteClose&&mensaje) && mensaje}
                      {(!permiteClose||!mensaje) && 'Esta usted seguro ?'}
                    </p>

                </Modal.Content>
                <Modal.Actions>
                    <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>handleQuestionUpdDel(ev)}>
                        <Icon dato1="No" name='remove' /> No
                    </Button>
                    <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>handleQuestionUpdDel(ev)}>
                        <Icon dato1="Si" name='checkmark' /> Si
                    </Button>
                </Modal.Actions>
            </Modal>
        }
    </div> 
    )
  }

export default SeguroPermite